import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ROUTES } from "@/lib/routes";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (authLoading) return;

    if (!user) {
      console.log('[ProtectedRoute] No user found, redirecting to auth');
      navigate(ROUTES.AUTH, { replace: true, state: { from: location } });
      return;
    }

    // Check role from user object directly
    if (user.role === "waitlisted") {
      console.log('[ProtectedRoute] User is waitlisted, redirecting to waitlist');
      navigate(ROUTES.WAITLIST, { replace: true });
      return;
    }
  }, [user, authLoading, navigate, location]);

  if (authLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="text-center space-y-4">
          <Loader2 className="h-12 w-12 animate-spin text-primary mx-auto" />
          <p className="text-muted-foreground">Verifying session...</p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};
